import { Component } from 'react';

import Router from 'next/router';

const initialState = { error: null };

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
    this.onUrlChanged = this.onUrlChanged.bind(this);
    Router.events.on('routeChangeComplete', this.onUrlChanged);
  }

  onUrlChanged () {
    this?.reset()
  }

  reset () {
    this.setState({error: null})
  }

  componentWillUnmount () {
    Router.events.off('routeChangeComplete', this.onUrlChanged);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.props.onError?.(error, info);
  }

  render() {
    const { error } = this.state;

    if (error !== null) {
      const { fallback: Fallback } = this.props;

      const contextValue = { error, reset: this.reset };

      return typeof Fallback === 'function' ? <Fallback {...contextValue} /> : Fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
